import type { ColorSpec } from './types';

/** Red color spec — uses the `fair-pink` Tailwind palette. */
export const red: ColorSpec = {
  filled: {
    border: 'border-fair-pink-700 dark:border-fair-pink-500',
    bg: 'bg-fair-pink-600 text-white dark:bg-fair-pink-700',
    bgActive: 'bg-fair-pink-800 text-white',
    hover: 'hover:bg-fair-pink-700 hover:text-white active:bg-fair-pink-800 active:text-white',
    hoverDark: 'dark:hover:bg-fair-pink-800 dark:hover:text-white dark:active:bg-fair-pink-900 dark:active:text-white',
  },
  outline: {
    border: 'border-fair-pink-400 dark:border-fair-pink-500',
    bg: 'bg-fair-pink-50 dark:bg-fair-pink-950 text-fair-pink-700 dark:text-fair-pink-200',
    bgActive: 'bg-fair-pink-600 dark:bg-fair-pink-500 text-white',
    hover: 'hover:bg-fair-pink-100 hover:text-fair-pink-800 active:bg-fair-pink-200 active:text-fair-pink-800',
    hoverDark:
      'dark:hover:bg-fair-pink-900 dark:hover:text-fair-pink-100 dark:active:bg-fair-pink-800 dark:active:text-fair-pink-100',
    hoverWhenActive: 'hover:bg-fair-pink-700 dark:hover:bg-fair-pink-600',
  },
  soft: {
    border: 'border-fair-pink-100 dark:border-fair-pink-900',
    bg: 'bg-fair-pink-50 dark:bg-fair-pink-950 text-fair-pink-700 dark:text-fair-pink-300 font-normal',
    bgActive: 'bg-fair-pink-600 dark:bg-fair-pink-500 text-white',
    hover: 'hover:bg-fair-pink-600 hover:text-white active:bg-fair-pink-700 active:text-white',
    hoverDark: 'dark:hover:bg-fair-pink-500 dark:hover:text-white dark:active:bg-fair-pink-600 dark:active:text-white',
    hoverWhenActive: 'hover:bg-fair-pink-700 dark:hover:bg-fair-pink-600',
  },
  textFilled: {
    text: 'text-fair-pink-700 dark:text-fair-pink-400',
    activeBg: 'bg-fair-pink-600 text-white',
    hover: 'hover:bg-fair-pink-600 hover:text-white active:bg-fair-pink-700',
    hoverDark: 'dark:hover:bg-fair-pink-700 dark:hover:text-white dark:active:bg-fair-pink-800',
  },
  textSoft: {
    text: 'text-fair-pink-700 dark:text-fair-pink-300 font-normal',
    activeBg: 'bg-fair-pink-600 text-white dark:bg-fair-pink-500',
    hover: 'hover:bg-fair-pink-100 hover:text-fair-pink-900 active:bg-fair-pink-200',
    hoverDark: 'dark:hover:bg-fair-pink-900 dark:hover:text-fair-pink-100 dark:active:bg-fair-pink-800',
  },
  tooltip: 'bg-fair-pink-600 dark:bg-fair-pink-700 text-white',
  badge: {
    filled: 'bg-fair-pink-600 dark:bg-fair-pink-700 text-white',
    soft: 'bg-fair-pink-400 dark:bg-fair-pink-500 text-white',
  },
  softIcon: 'text-fair-pink-700 dark:text-fair-pink-200 group-hover/btn:text-current',
  underline: {
    filled:
      '[&_u]:text-fair-pink-200 dark:[&_u]:text-fair-pink-300 [&_u]:decoration-fair-pink-300 dark:[&_u]:decoration-fair-pink-400',
    outline:
      '[&_u]:text-fair-pink-800 dark:[&_u]:text-fair-pink-300 [&_u]:decoration-fair-pink-600 dark:[&_u]:decoration-fair-pink-400',
    soft: '[&_u]:text-fair-pink-800 dark:[&_u]:text-fair-pink-300 [&_u]:decoration-fair-pink-300 dark:[&_u]:decoration-fair-pink-400',
  },
  input: {
    filled: {
      border: 'border-fair-pink-700 dark:border-fair-pink-500',
      bg: 'bg-fair-pink-600 dark:bg-fair-pink-700',
      focusBg: 'focus-within:bg-fair-pink-700 dark:focus-within:bg-fair-pink-800',
      focusOutline:
        'focus-within:outline-solid focus-within:outline-2 focus-within:outline-offset-1 focus-within:outline-fair-pink-700 dark:focus-within:outline-fair-pink-500',
      hoverActive:
        'hover:bg-fair-pink-700 hover:text-white active:bg-fair-pink-800 active:text-white dark:hover:bg-fair-pink-800 dark:active:bg-fair-pink-900',
      readOnlyBg: 'bg-fair-pink-500 dark:bg-fair-pink-800',
      text: 'text-white',
    },
    outline: {
      border: 'border-fair-pink-400 dark:border-fair-pink-500',
      bg: 'bg-fair-pink-50 dark:bg-fair-pink-950',
      focusBg: 'focus-within:bg-fair-pink-100 dark:focus-within:bg-fair-pink-900',
      focusOutline:
        'focus-within:outline-solid focus-within:outline-2 focus-within:outline-offset-1 focus-within:outline-fair-pink-400 dark:focus-within:outline-fair-pink-500',
      hoverActive:
        'hover:bg-fair-pink-100 hover:text-fair-pink-800 active:bg-fair-pink-200 active:text-fair-pink-800 dark:hover:bg-fair-pink-900 dark:hover:text-fair-pink-100 dark:active:bg-fair-pink-800 dark:active:text-fair-pink-100',
      readOnlyBg: 'bg-fair-pink-50 dark:bg-fair-pink-900',
      text: 'text-fair-pink-700 dark:text-fair-pink-200',
    },
    soft: {
      border: 'border-fair-pink-100 dark:border-fair-pink-900',
      bg: 'bg-fair-pink-50 dark:bg-fair-pink-950',
      focusBg: 'focus-within:bg-fair-pink-100 dark:focus-within:bg-fair-pink-900',
      focusOutline:
        'focus-within:outline-solid focus-within:outline-2 focus-within:outline-offset-1 focus-within:outline-fair-pink-100 dark:focus-within:outline-fair-pink-900',
      hoverActive:
        'hover:bg-fair-pink-100 hover:text-fair-pink-900 active:bg-fair-pink-200 active:text-fair-pink-950 dark:hover:bg-fair-pink-900 dark:hover:text-fair-pink-100 dark:active:bg-fair-pink-800 dark:active:text-fair-pink-100',
      readOnlyBg: 'bg-fair-pink-50 dark:bg-fair-pink-900',
      text: 'text-fair-pink-700 dark:text-fair-pink-300',
    },
  },
  inputMuted: {
    filled: 'text-white',
    outline: 'text-fair-pink-400 dark:text-fair-pink-700',
    soft: 'text-fair-pink-400 dark:text-fair-pink-700',
  },
  inputPlaceholder: {
    filled: 'placeholder:text-white',
    outline: 'placeholder:text-fair-pink-400 dark:placeholder:text-fair-pink-700',
    soft: 'placeholder:text-fair-pink-400 dark:placeholder:text-fair-pink-700',
  },
  group: {
    filled: 'border-fair-pink-300 dark:border-fair-pink-700 bg-fair-pink-50 dark:bg-fair-pink-950',
    outline: 'border-fair-pink-400 dark:border-fair-pink-500 bg-fair-pink-50 dark:bg-fair-pink-950',
    soft: 'border-fair-pink-200 dark:border-fair-pink-800 bg-fair-pink-100 dark:bg-fair-pink-900',
  },
  groupDivider: {
    filled: 'bg-fair-pink-300 dark:bg-fair-pink-700',
    outline: 'bg-fair-pink-300 dark:bg-fair-pink-600',
    soft: 'bg-fair-pink-200 dark:bg-fair-pink-700',
  },
  segment: {
    filled: 'border-fair-pink-300 dark:border-fair-pink-700 bg-fair-pink-50 dark:bg-fair-pink-950',
    outline: 'border-fair-pink-400 dark:border-fair-pink-500 bg-fair-pink-50 dark:bg-fair-pink-950',
  },
  segmentDivider: {
    filled: 'bg-fair-pink-300 dark:bg-fair-pink-700',
    outline: 'bg-fair-pink-300 dark:bg-fair-pink-600',
  },
  popoverHighlight: 'bg-fair-pink-600 text-white',
  popoverText: 'text-fair-pink-700 dark:text-fair-pink-200',
  popoverBorder: 'border-fair-pink-200 dark:border-fair-pink-700',
};
